/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>groups-store.service.ts</name>
///
/// <description>
///  A service that caches account groups
///  Follwoing http://blog.angular-university.io/how-to-build-angular2-apps-using-rxjs-observable-data-services-pitfalls-to-avoid/
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>01 Dec 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 01Dec16 YH  1.0.0000         Task 9540:Cache Hydrogen Account's Groups, Devices, etc. in H2 Portal
/// 12Jan16 YH  1.0.0000         Task 10848:Update Group Tree on SignalR Event
/// 08Feb17 YH                   Bug 117923 - Device Detail - Breadcrumbs dont appear on first click of device in tree
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import 'rxjs/add/operator/retry';

import {Http, Response} from '@angular/http';
import {MockBackend} from '@angular/http/testing';
import {HydUser} from '../../models/user';
import {LogService} from '../log.service';
import {hydUtilService} from '../../utils/hydUtils.service';
import {GroupApiService,GroupAPI,GroupsSearch} from '../Crestron.HydrogenAPI.GroupApi.service';
//YH 1/12/2017 
import {MediatorService} from '../mediator.service';
import {MediatorEventLookup} from '../mediator-event-lookup.service';


@Injectable()
export class GroupStoreService { 

    private DEVICE_MODEL: string = "MERCURY";
    //private groupsObservable: Observable<Group[]>
    private groupsSubject: BehaviorSubject<GroupAPI[]>;
    private dataStore: {
        groups: GroupAPI[]
    };
    private GroupStoreSessionStorageName = "GroupStore";

    public get GroupsObservable() : Observable<GroupAPI[]> {
        return this.groupsSubject.asObservable();
    }

    public get GroupsData() : GroupAPI[] {
        return Object.assign({}, this.dataStore).groups;
    }

    constructor (
        private _groupApiService : GroupApiService,
        private _hydUser: HydUser,
        private _logService : LogService,
        private _mediator:MediatorService
    )
    {
        //this.dataStore = { groups: [] };
        this.LoadDataStoreFromSessionStorage();
        this.groupsSubject = <BehaviorSubject<GroupAPI[]>>new BehaviorSubject([]);        
    }

    public Start() {
        // YH 2/8/2017 117923
        this._hydUser.AuthorizationObservable.subscribe(
            isLoggedon => {
                let search: GroupsSearch = new GroupsSearch({
                    accountId:this._hydUser.AccountId
                    ,sortBy:"GroupName"
                });
                this.LoadInitialData(search);
            }
        );

        //YH 1/12/2017 Task 10848
        this.subscribeToGroupUpdateEvents();

    }
    
    private LoadInitialData(search: GroupsSearch) {
        let start : Date = new Date();
        
        this._groupApiService.getGroups(search)
            .retry(3)
            .subscribe(
                groups => {
                    let end : Date = new Date();
                    console.debug(hydUtilService.TimeStamp() + " group-store.service LoadInitialData() fetched " +groups.length+ " groups for account "+search.accountId + " in " + hydUtilService.TimeLapsMilliseconds(start,end));
                    //Store the groups from the API in local memory
                    this.dataStore.groups = groups;

                    this.StoreDataInSessionStorage();

                    this.NotifySubscribersOnNewData();
                    
                },
                err => this._logService.logMessage("group-store.service LoadInitialData() failed fetching groups for account "+search.accountId)
            );                                
    }

    //YH 1/12/2017 Task 10848
    private subscribeToGroupUpdateEvents() : void {
        this._mediator.Event(MediatorEventLookup.GroupUpdate).subscribe(
            (updateGroup) => {
                this.updateGroupStore(updateGroup.GroupID);
            }
        );
    }
    
    private LoadDataStoreFromSessionStorage() {
        this.dataStore = { groups: [] };
        if (typeof(Storage) !== "undefined" && sessionStorage[this.GroupStoreSessionStorageName]) {
            let parsedDataStore = JSON.parse(sessionStorage[this.GroupStoreSessionStorageName]);
            //YH 2/9/2017 need to parse each group as it is still a json
            parsedDataStore.groups.map(groupJson=> {
                //let groupAPI:GroupAPI = new GroupAPI(groupJson); 
                let groupAPI: GroupAPI = GroupAPI.fromJS(groupJson); 
                this.dataStore.groups.push(groupAPI);
            });            
        }        
    }

    private StoreDataInSessionStorage() {
        let groupsJson : Array<string> = new Array<string>();
        this.dataStore.groups.map(group=> groupsJson.push(group.toJSON()));
        let dataStoreJson = { groups:groupsJson};
        sessionStorage.setItem(this.GroupStoreSessionStorageName,JSON.stringify(dataStoreJson));
    }

    // public get Groups() : Observable<Group[]> {
    //     return new Observable<Group[]>(fn => this._values.subscribe(fn));
    // }

    // public CreateGroup(group:Group) {
    //     let obs = this._groupApiService.createGroup(group)

    //     obs.subscribe(
    //         createdObject => {
    //             this.InsertGroupIntoCache(createdObject);                    
    //         },
    //         //TODO notify the user that the group was not created in the backend
    //         error => {}
    //     );     
    // }

    public updateGroupStore(groupId:string) : void {
        var deviceModelType = (sessionStorage["modelType"]) ? JSON.parse(sessionStorage["modelType"]) : this.DEVICE_MODEL;
        let obs: any = this._groupApiService.getGroupById(groupId, deviceModelType);
        //Subscribe to the update group observable and update the local cache after the group was successfuly updated by the API
        obs.subscribe(
            updatedGroup => {
                this.UpdateGroupInCache(updatedGroup);                
            },
            //TODO notify the user that the group was not created in the backend
            error => {}
        );        
    }

    // public DeleteGroup(groupId: string) {
    //     this._groupApiService.deleteGroup(groupId).subscribe(
    //         deletedGroup => {
                
    //             this.RemoveGroupFromCache(groupId);

    //             this.NotifySubscribersOnNewData();
                
    //         }, 
    //         error => this._logService.logMessage('Failed to delete group '+ groupId)
    //     );
    // }

    private NotifySubscribersOnNewData() {
        //Object.assign creates a copy of the data, not returning a reference to the real data. 
        this.groupsSubject.next(Object.assign({}, this.dataStore).groups);
    }

    public InsertGroupIntoCache(group:GroupAPI) {
       this.dataStore.groups.push(group);  
       this.StoreDataInSessionStorage();
    }

    public UpdateGroupInCache(group:GroupAPI) {
        this.RemoveGroupFromCache(group.groupData.id);
        this.InsertGroupIntoCache(group);
    }

    public RemoveGroupFromCache(groupId:string) {
        if (groupId) {
            let removeIndex = this.dataStore.groups.map(grp=> grp.groupData.id).indexOf(groupId);
            ~removeIndex && this.dataStore.groups.splice(removeIndex,1);
        }
    }


}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/group-store/group-store.service.ts